import { FC, useContext } from 'react';
import common from '../../util/scss/common.module.scss';
import styles from './ConfirmStaffAccountForm.module.scss';
import GlobalContext from '../../contexts/GlobalContext';
import Card from '../Card/Card';
import CoBranding from '../CoBranding/CoBranding';
import ConfirmStaffAccountContext, { EConfirmStaffAccountUiState } from '../../contexts/ConfirmStaffAccountContext';
import PasswordInput from '../PasswordInput/PasswordInput';
import PasswordValidator from '../PasswordValidator/PasswordValidator';
import { Box, MenuItem, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const ConfirmStaffAccountForm: FC = () => {
    const { coBranding, language, countriesList } = useContext(GlobalContext);
    const {
        confirmStaffAccountUiState,
        firstName,
        setFirstName,
        firstNameValidationMessage,
        firstNameIsValid,
        lastName,
        setLastName,
        lastNameValidationMessage,
        lastNameIsValid,
        email,
        password,
        setPassword,
        countryCode,
        setCountryCode,
        disableSubmit,
        submitConfirmAccount,
    } = useContext(ConfirmStaffAccountContext);

    const handleSubmitForm = (event) => {
        event.preventDefault();
        submitConfirmAccount();
    };

    return (
        <Card>
            {(coBranding.logoUrl || coBranding.name) && (
                <CoBranding logoUrl={coBranding.logoUrl} name={coBranding.name} />
            )}
            <h1 className={common.pageHeader}>{language.confirmStaffAccount.header}</h1>
            <form data-testid="confirm-staff-account-form">
                <main className={styles.confirmAccountForm}>
                    <TextField
                        label={language.createAccount.form.firstName}
                        value={firstName}
                        error={!firstNameIsValid}
                        helperText={!firstNameIsValid && firstNameValidationMessage}
                        onChange={(event) => setFirstName(event.target.value)}
                        margin="normal"
                        fullWidth
                    />
                    <TextField
                        label={language.createAccount.form.lastName}
                        value={lastName}
                        error={!lastNameIsValid}
                        helperText={!lastNameIsValid && lastNameValidationMessage}
                        onChange={(event) => setLastName(event.target.value)}
                        margin="normal"
                        fullWidth
                    />
                    <TextField
                        label={language.createAccount.form.email}
                        value={email}
                        disabled={true}
                        sx={{ my: 2 }}
                        fullWidth
                    />
                    <PasswordInput
                        value={password}
                        label={language.createAccount.form.password}
                        onChange={(event) => setPassword(event.target.value)}
                        autoFocus={true}
                    />
                    <Box sx={{ my: 2 }}>
                        <PasswordValidator password={password} />
                    </Box>
                    <TextField
                        select
                        label={language.createAccount.form.country}
                        fullWidth
                        margin="normal"
                        value={countryCode}
                        onChange={(event) => setCountryCode(event.target.value)}
                    >
                        {countriesList.map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                                {country.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <section className={styles.confirmAccountCTA}>
                        <LoadingButton
                            variant="contained"
                            type="submit"
                            size="large"
                            disabled={
                                disableSubmit || confirmStaffAccountUiState === EConfirmStaffAccountUiState.loading
                            }
                            onClick={handleSubmitForm}
                            loading={confirmStaffAccountUiState === EConfirmStaffAccountUiState.loading}
                            className={common.buttonShim}
                        >
                            {language.common.confirm}
                        </LoadingButton>
                    </section>
                </main>
            </form>
        </Card>
    );
};

export default ConfirmStaffAccountForm;
